import {ApplicationRoute, LOCALIZED_ROUTE_TOKEN} from '../../craft/utils/application.route'

export const AGENT_ROUTES = {
  AGENT: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent`), // hardcoded in app-routing user-default-route for tree shaking routes
  AGENT_HOME: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/home`),
  AGENT_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs`),
  AGENT_JOBS_ACTION_NEEDED: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/actions`, 'actions'),
  AGENT_JOBS_IN_PROGRESS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/wip`, 'wip'),
  AGENT_JOBS_COMPLETED: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/completed`, 'completed'),
  AGENT_JOBS_ALL: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/all`, 'all'),
  AGENT_PROS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros`),
  AGENT_PROS_ALL: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros/all`, 'all'),
  AGENT_PROS_INVITATIONS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros/invitations`, 'invitations'),

  AGENT_JOB_DETAILS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/:id`, 'jobs/:id'),
  AGENT_JOB_DETAILS_PROS_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/:id/pros`, 'pros'),
  AGENT_JOB_DETAILS_DETAILS_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/:id/details`, 'details'),
  AGENT_JOB_COST_OVERVIEW: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/agent/jobs/:jobId/cost-overview/:proId`,
    'jobs/:jobId/cost-overview/:proId',
  ),
  AGENT_PRO_DETAILS_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros/:id/jobs`, 'pros/:id/jobs'),
  AGENT_PRO_DETAILS_JOBS_ASSIGNED: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros/:id/jobs/assigned`),
  AGENT_PRO_DETAILS_JOBS_ACCEPTED: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros/:id/jobs/accepted`),
  AGENT_PRO_DETAILS_JOBS_DECLINED: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros/:id/jobs/declined`),
  AGENT_PRO_DETAILS_JOBS_WON: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/agent/pros/:id/jobs/won`),
}
